import { AbstractApiClient } from "../AbstractApiClient/AbstractApiClient";
import { generateCheckPreview } from "./routes/generateCheckPreview/generateCheckPreview";
import { generateAccrualPreviews } from "./routes/generateAccrualPreviews/generateAccrualPreviews";
import { postPreviewCheckData } from "./routes/postPreviewCheckData/postPreviewCheckData";
import { preProcessChecks } from "./routes/preProcessChecks/preProcessChecks";
import { preProcessChecksById } from "./routes/preProcessChecksById/preProcessChecksById";
import { preProcessChecksV2 } from "./routes/preProcessChecksV2/preProcessChecksV2";
import { processChecksByEmployerCheckId } from "./routes/processChecksByEmployerCheckId/processChecksByEmployerCheckId";
import {
  assertValidPicardSchema,
  PicardSchemaAssertionWithParams,
} from "./validation-types/assertValidPicardSchema";

export class PicardClient extends AbstractApiClient {
  public static AssertValidSchema: PicardSchemaAssertionWithParams =
    assertValidPicardSchema;
  public readonly PostPreviewCheckData = postPreviewCheckData(this.Instance);
  public readonly PreProcessChecks = preProcessChecks(this.Instance);
  public readonly PreprocessChecksV2 = preProcessChecksV2(this.Instance);
  public readonly PreProcessChecksById = preProcessChecksById(this.Instance);
  public readonly ProcessChecksByEmployerCheckId =
    processChecksByEmployerCheckId(this.Instance);
  public readonly GenerateCheckPreview = generateCheckPreview(this.Instance);
  public readonly GenerateAccrualPreviews = generateAccrualPreviews(
    this.Instance
  );
}
